import {
  updateScheduleAction,
  getScheduleAction,
  getLastWateredAction,
  runScheduleAction,
  getDatesAction,
  getScheduleForDayAction,
  getCurrentWateringAction,
  modifyScheduleAction,
  addScheduleAction,
  deleteScheduleAction,
  setCurrentWateringAction,
  stopWateringAction,
  skipWateringAction,
} from './actions';

const updateSchedule = (dispatch) => (payload) => dispatch(updateScheduleAction(payload));
const getSchedule = (dispatch) => (payload) => dispatch(getScheduleAction(payload));
const getLastWatered = (dispatch) => (payload) => dispatch(getLastWateredAction(payload));
const runSchedule = (dispatch) => (payload) => dispatch(runScheduleAction(payload));
const getDates = (dispatch) => (payload) => dispatch(getDatesAction(payload));
const getScheduleForDay = (dispatch) => (payload) => dispatch(getScheduleForDayAction(payload));
const getCurrentWatering = (dispatch) => (payload) => dispatch(getCurrentWateringAction(payload));
const setCurrentWatering = (dispatch) => (payload) => dispatch(setCurrentWateringAction(payload));
const modifySchedule = (dispatch) => (payload) => dispatch(modifyScheduleAction(payload));
const addSchedule = (dispatch) => (payload) => dispatch(addScheduleAction(payload));
const deleteSchedule = (dispatch) => (payload) => dispatch(deleteScheduleAction(payload));
const stopWatering = (dispatch) => (payload) => dispatch(stopWateringAction(payload));
const skipWatering = (dispatch) => (payload) => dispatch(skipWateringAction(payload));

const operations = {
  updateSchedule,
  getSchedule,
  getLastWatered,
  runSchedule,
  getDates,
  getScheduleForDay,
  getCurrentWatering,
  modifySchedule,
  addSchedule,
  deleteSchedule,
  setCurrentWatering,
  stopWatering,
  skipWatering,
};

export default operations;
